import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", org_name: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await register(form);
      toast.success("Hesabınız oluşturuldu");
      nav("/dashboard");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50 dark:bg-slate-950">
      <Card className="w-full max-w-md p-8">
        <div className="flex items-center gap-2 mb-6">
          <img src="/icon-192.png" alt="WorkHub" className="h-9 w-9 rounded-lg" />
          <span className="text-lg font-bold font-display">WorkHub</span>
        </div>
        <h1 className="text-2xl font-bold font-display">Hesap oluşturun</h1>
        <p className="text-sm text-muted-foreground mt-1 mb-6">Kuruluşunuzu dakikalar içinde kurun</p>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Ad Soyad</Label><Input value={form.name} onChange={set("name")} required data-testid="register-name-input" className="mt-1.5" /></div>
          <div><Label>Kuruluş Adı</Label><Input value={form.org_name} onChange={set("org_name")} placeholder="Örn. Demo Şirketi" data-testid="register-org-input" className="mt-1.5" /></div>
          <div><Label>E-posta</Label><Input type="email" value={form.email} onChange={set("email")} required data-testid="register-email-input" className="mt-1.5" /></div>
          <div><Label>Şifre</Label><Input type="password" value={form.password} onChange={set("password")} required minLength={6} data-testid="register-password-input" className="mt-1.5" /></div>
          {error && <p className="text-sm text-rose-600" data-testid="register-error">{error}</p>}
          <Button type="submit" className="w-full" disabled={loading} data-testid="register-submit-button">
            {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Kayıt Ol
          </Button>
        </form>
        <p className="text-sm text-center mt-4 text-muted-foreground">
          Zaten hesabınız var mı? <Link to="/login" className="text-primary font-medium hover:underline">Giriş yapın</Link>
        </p>
      </Card>
    </div>
  );
}
